

export class TopicQuiz {

    protected readonly quiz: HTMLElement;

    protected interimResultCorrect: HTMLElement[] = [];
    protected interimResultWrong: HTMLElement[] = [];

    protected finalPage: HTMLElement;
    protected finalResultSuccess: HTMLElement;
    protected finalResultFail: HTMLElement;

    protected questions: HTMLElement[] = []
    protected optionsByQuestion: HTMLElement[][] = [];

    protected currentQuestionIndex: number = 0;

    protected totalCorrect: number = 0;

    constructor(quiz: HTMLElement) {
        this.quiz = quiz;

        this.resolveElements();
        this.addListeners();
        this.showQuestion();
    }

    protected resolveElements() {
        this.quiz.querySelectorAll<HTMLElement>('[data-topic-quiz-interim-result-correct]').forEach(result => {
            const question = result.dataset.topicQuizInterimResultCorrect;
            if (!question) return;
            this.interimResultCorrect[question] = result;
        });

        this.quiz.querySelectorAll<HTMLElement>('[data-topic-quiz-interim-result-wrong]').forEach(result => {
            const question = result.dataset.topicQuizInterimResultWrong;
            if (!question) return;
            this.interimResultWrong[question] = result;
        });

        this.finalPage = this.quiz.querySelector<HTMLElement>('[data-topic-quiz-final-page]');

        this.finalResultSuccess = this.finalPage.querySelector<HTMLElement>('[data-topic-quiz-final-result-success]');
        this.finalResultFail = this.finalPage.querySelector<HTMLElement>('[data-topic-quiz-final-result-fail]');

        this.quiz.querySelectorAll<HTMLElement>("[data-topic-quiz-question]").forEach(question => {
            this.questions[question.dataset.topicQuizQuestion] = question;
        });

        this.questions.forEach((question, key) => {
            question.querySelectorAll<HTMLElement>("[data-topic-quiz-option]").forEach((option) => {
                this.optionsByQuestion[key] = this.optionsByQuestion[key] ?? [];
                this.optionsByQuestion[key][option.dataset.topicQuizOption] = option;
            });
        });
    }

    protected addListeners() {
        this.optionsByQuestion.forEach((options, question) => {
            options.forEach((option, key) => {
                option.addEventListener("change", () => {
                    this.clickOption(question, key);
                });
            });
        });
    }

    protected showQuestion() {
        this.questions.forEach((question, key) => {
            if (key === this.currentQuestionIndex) {
                question.classList.add("c-topic-quiz__content--active");
            } else {
                if (question.classList.contains("c-topic-quiz__content--active")) {
                    question.classList.add("c-topic-quiz__content--out")
                }
                question.classList.remove("c-topic-quiz__content--active");
            }
        });

        if (!this.questions[this.currentQuestionIndex]) {
            this.finish();
        }
    }

    protected clickOption(question: number, option: number) {
        if (question !== this.currentQuestionIndex) return;
        this.showInterimResult(question, option === 0);
        this.totalCorrect += option === 0 ? 1 : 0;
        this.currentQuestionIndex += 1;
        this.showQuestion();
    }

    protected showInterimResult(question: number, correct: boolean) {
        const correctResult = this[`interimResult${correct?'Correct':'Wrong'}`][question];
        const wrongResult = this[`interimResult${correct?'Wrong':'Correct'}`][question];
        if (!correctResult || !wrongResult) return;
        correctResult.classList.remove("d-none", "opacity-0");
        wrongResult.classList.add("d-none");
    }

    protected finish() {
        if (this.totalCorrect < Math.floor(this.questions.length/2)) {
            this.finalResultFail.querySelector('[data-topic-quiz-insert-correct]').innerHTML = `${this.totalCorrect}`
            this.finalResultFail.classList.remove("d-none")
        } else {
            this.finalResultSuccess.querySelector('[data-topic-quiz-insert-correct]').innerHTML = `${this.totalCorrect}`
            this.finalResultSuccess.classList.remove("d-none")
        }

        this.finalPage.classList.add('c-topic-quiz__content--active')
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('[data-topic-quiz]').forEach(value => {
        new TopicQuiz(value)
    })
})
